import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: 'app-eft-authorize-agreement',
  templateUrl: './eft-authorize-agreement.component.html',
  styleUrls: ['./eft-authorize-agreement.component.scss']
})
export class EftAuthorizeAgreementComponent extends FieldType<FieldTypeConfig> {
}
